interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  const btnBase =
    "min-w-[36px] h-9 px-3 rounded-md text-sm flex items-center justify-center cursor-pointer transition-colors whitespace-nowrap";

  return (
    <nav
      aria-label="分页导航"
      className="flex items-center justify-center gap-2 flex-wrap mt-10"
    >
      <button
        type="button"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={`${btnBase} border border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onPageChange(p)}
          aria-current={p === currentPage ? "page" : undefined}
          className={`${btnBase} ${
            p === currentPage
              ? "bg-primary-500 text-background-50 border border-primary-500"
              : "border border-background-200 text-foreground-600 hover:bg-background-100"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className={`${btnBase} border border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}